import { createAsyncThunk } from '@reduxjs/toolkit';
import { DemographicKind, DemographicModel } from 'api/dto/Demographic.dto';
import { serializeError } from 'shared/utils/redux';
import { demographicApi } from 'container/demographicApi';
import { saveFile } from 'shared/utils/saveFile';

import { STORE_NAME } from './initialState';

export const fetchDemographicList = createAsyncThunk(
  `${STORE_NAME}/fetchDemographicList`,
  ({ projectId }: { projectId: number }) => {
    return demographicApi.list(projectId);
  },
  { serializeError },
);

export const fetchReportDemographicList = createAsyncThunk(
  `${STORE_NAME}/fetchReportDemographicList`,
  ({ projectId }: { projectId: number }) => {
    return demographicApi.listReport(projectId);
  },
  { serializeError },
);

export const createDemographic = createAsyncThunk(
  `${STORE_NAME}/createDemographic`,
  ({ projectId, data }: { projectId: number; data: DemographicModel }) => {
    return demographicApi.create(projectId, data);
  },
  { serializeError },
);

export const updateDemographic = createAsyncThunk(
  `${STORE_NAME}/updateDemographic`,
  ({ projectId, data }: { projectId: number; data: DemographicModel }) => {
    return demographicApi.update(projectId, data.id, data);
  },
  { serializeError },
);

export const uploadDemographicsDry = createAsyncThunk(
  `${STORE_NAME}/uploadDemographicsDry`,
  ({ projectId, file }: { projectId: number; file: File }) => {
    return demographicApi.preview(projectId, file);
  },
  { serializeError },
);

export const uploadDemographics = createAsyncThunk(
  `${STORE_NAME}/uploadDemographics`,
  ({ projectId, file }: { projectId: number; file: File }) => {
    return demographicApi.upload(projectId, file);
  },
  { serializeError },
);

export const downloadChangeReport = createAsyncThunk(
  `${STORE_NAME}/downloadChangeReport`,
  ({ file, projectId }: { file: File; projectId: number }) => {
    return demographicApi
      .downloadChangeReport(projectId, file)
      .then((blob) => saveFile(blob, `demographic-changes-${projectId}`));
  },
  { serializeError },
);

export const createDefaultDemographic = createAsyncThunk(
  `${STORE_NAME}/createDefaultDemographic`,
  ({ projectId, data }: { projectId: number; data: DemographicModel }) => {
    return demographicApi.createDefault(projectId, data);
  },
  { serializeError },
);

export const deleteDemographic = createAsyncThunk(
  `${STORE_NAME}/deleteDemographic`,
  ({ projectId, demographicId }: { projectId: number; demographicId: number }) => {
    return demographicApi.delete(projectId, demographicId).then(() => demographicId);
  },
  { serializeError },
);

export const moveDemographic = createAsyncThunk<
  void,
  {
    projectId: number;
    oldDemographicList: DemographicModel[];
    newDemographicList: DemographicModel[];
    kind: DemographicKind;
  }
>(
  `${STORE_NAME}/moveDemographic`,
  async ({ projectId, newDemographicList }) => {
    await demographicApi.reorder(
      projectId,
      newDemographicList.map((item) => item.id),
    );
  },
  { serializeError },
);
